import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import AlarmRecord from '@/components/alarmRecord/AlarmRecord'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/register',
      name: 'Login',
      component: Login,
      meta: {
        title: '账号注册'
      }
    },
    {
      path: '',
      redirect: '/register',
      component: Login,
      meta: {
        title: '账号注册'
      }
    },
    {
      path: '/alarmRecord',
      name: 'AlarmRecord',
      component: AlarmRecord,
      meta: {
        title: '未处理事件'
      }
    },
    {
      path: '/helloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/binding',
      component: () => import('@/components/bind/Bind'),
      meta: {
        title: '账号绑定'
      }
    },
    {
      path: '/unBound',
      component: () => import('@/components/bind/Unbind'),
      meta: {
        title: '账号解绑'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js